import { Action, createReducer, on } from "@ngrx/store";
import { MenuItem } from "primeng/api";
import { clearMenusState, saveMenusState } from "../actions/menus.actions";

export const initialMenusState: MenuItem[] = [];

const _menusReducer = createReducer(
  initialMenusState,
  on(
    saveMenusState,
    (_state: MenuItem[], newValue: { menus: MenuItem[] }) => newValue.menus,
  ),
  on(clearMenusState, () => []),
);

export function menusReducer(state: MenuItem[] | undefined, action: Action) {
  return _menusReducer(state, action);
}
